import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  activateHeader: 'STEP 2: Upload your documents here',
  activateValidate: 'STEP 1: Verify your email here',
  activateValidateSuccess: 'STEP 1: Email verified successfully',
  activateViewTitle: 'STEP 1: Verify your email',
  activateBody:
    'We have sent an email to {{email}} to complete the verification.',
  activateSpam:
    "If you didn't receive it, please check your spam folder or click Resend email below.",
  activateResend: 'Resend email',
  activateReturnDashboard: 'Return to the dashboard',
  activateStepContinue: 'Continue',
  activateWelcome:
    'To unlock the full power of your EFEX global account, you need to complete a few steps:',
  activateResendSuccess: 'Email sent successfully',
  activateResendError: 'Error sending email, try again later',
  activateResendMaxTries:
    'You have reached the maximum number of attempts, try again later',
  activateGoBack: 'Go back',
  activateSuccessMessage: 'successfully verified.',
  activationError: 'Activation failed',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const ACTIVATE_ACCOUNT_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    activateHeader: 'PASO 2: Sube tus documentos aquí',
    activateValidate: 'PASO 1: Verifica tu email aquí',
    activateViewTitle: 'PASO 1: Verifica tu email',
    activateValidateSuccess: 'PASO 1: ¡Email verificado con éxito!',
    activateBody:
      'Te enviamos un correo a {{email}} para que completes la verificación.',
    activateSpam:
      'Si no lo recibiste, revisa tu carpeta de spam o haz clic en Reenviar correo abajo.',
    activateResend: 'Reenviar correo',
    activateReturnDashboard: 'Volver al dashboard',
    activateStepContinue: 'Continuar',
    activateWelcome:
      'Para desbloquear todo el poder de tu cuenta global EFEX, debes completar un par de pasos:',
    activateResendSuccess: 'Correo enviado exitosamente',
    activateResendError: 'Error al enviar correo, intenta más tarde',
    activateResendMaxTries:
      'Has alcanzado el máximo de intentos, intenta más tarde',
    activateGoBack: 'Atrás',
    activateSuccessMessage: 'verificado exitosamente.',
    activationError: 'Error al activar la cuenta',
  },
};

export default ACTIVATE_ACCOUNT_LANGUAGE_LABELS;
